import { Typography } from 'antd'
import React from 'react'
import { Suppliers } from '..'
import { SuppliersSupplierDealFragment } from '../Suppliers.generated-types'
import { SECTION_HEADING_DIV } from './styles'

interface SuppliersWrapperProps {
  supplierDeals: SuppliersSupplierDealFragment[]
}

// Used when the Suppliers component is wanted to be used with a section heading.

export const SuppliersWrapper = ({
  supplierDeals,
}: SuppliersWrapperProps): JSX.Element => {
  const { Text } = Typography

  return (
    <>
      {' '}
      <div style={SECTION_HEADING_DIV}>
        <Text strong>Review your extras</Text>
      </div>{' '}
      <Suppliers supplierDeals={supplierDeals} />{' '}
    </>
  )
}
